import { memo } from 'react'
import type { StyleProps } from 'src/types'

import S from './Icon.style'
import * as icons from './svg'

export type Props = {
  name: keyof typeof icons
  size?: number
  color?: string
} & StyleProps

const Icon = ({ name, size = 16, color, style, className }: Props) => {
  const SVGIcon = icons[name]

  return (
    <SVGIcon
      css={S.basic}
      style={{ width: size, color, ...style }}
      data-svg-name={name}
      className={className}
    />
  )
}

export type IconType = (typeof iconTypes)[number]
export const iconTypes: Props['name'][] = Object.keys(icons).filter((name) => {
  return !name.startsWith('check_') && !name.startsWith('uncheck_')
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}) as any[]

export default memo(Icon)
